import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Divider } from '@mui/material';
import { useDashboardContext } from '@shared/contexts/DashboardContext';

export default function CloseConfirmDialog({
  open,
  setOpen,
  onClose,
  id,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  id: string;
}) {
  const { deleteWidgetById } = useDashboardContext();
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Close Confirmation</DialogTitle>
      <Divider />
      <DialogContent>Are you sure you want to close this widget?</DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button
          onClick={() => {
            setOpen(false);
            onClose?.();
            deleteWidgetById(id);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
